export default __webpack_public_path__ + "static/media/initial-drop-date.c5c66245.svg";